import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useApi from "../../hooks/useApi";
import ProductListing from "../salesInvoice/ProductsModal";

const StockManagement = () => {
  const location = useLocation();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState(
    // Initialize search query from navigation state when available
    (location && location.state && location.state.searchQuery) || "",
  );
  const [searchBy, setSearchBy] = useState("UNIVERSAL");

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(250);
  const [totalRows, setTotalRows] = useState(0);

  const { request: dataRequest } = useApi();
  const { request: countRequest } = useApi();

  const COMPANY_CODE = localStorage.getItem("companyCode");
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const DEPARTMENT_LOCATIOIN =
    localStorage.getItem("departmentLocation") || "A";

  // Fetch total count for stock listing with search filter
  const fetchTotalCount = useCallback(
    async (query = searchQuery, searchByValue = searchBy) => {
      try {
        const effectiveQuery =
          query?.trim() === "" ? "-" : query?.trim() || "-";
        const formattedQuery = effectiveQuery.replace(/\//g, "%2F");
        const url = `${BASE_URL}/api/cpayscount/${COMPANY_CODE}/ITEMCOUNT/${searchByValue}/${formattedQuery}`;
        const response = await countRequest({
          url: url,
          method: "GET",
          // timeout: 5000,
        });
        if (Array.isArray(response) && response[0]?.CNT) {
          setTotalRows(Number(response[0].CNT));
        } else {
          setTotalRows(0);
        }
      } catch (err) {
        console.error("Failed to fetch total count", err);
        setTotalRows(0);
      }
    },
    [BASE_URL, COMPANY_CODE, searchQuery, searchBy],
  );

  const fetchProductData = useCallback(
    async (
      query,
      searchByValue,
      location = DEPARTMENT_LOCATIOIN,
      page = pageNumber,
      limit = pageSize,
    ) => {
      // Empty string to "-"
      const effectiveQuery = query?.trim() === "" ? "-" : query?.trim() || "-";
      const formattedQuery = effectiveQuery.replace(/\//g, "%2F");

      try {
        setLoading(true);
        const url = `${BASE_URL}/api/CRMStockListPage/${COMPANY_CODE}/${searchByValue}/${formattedQuery}/${location}/-/${page}/${limit}`;
        const response = await dataRequest({
          url: url,
          method: "GET",
          // timeout: 5000,
        });
        if (response) {
          setProducts(response);
          console.log("Response of the item", response);
        } else {
          setProducts([]);
        }
      } catch (err) {
        console.error("Failed to fetch product data", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL, COMPANY_CODE, DEPARTMENT_LOCATIOIN, pageNumber, pageSize],
  );

  useEffect(() => {
    fetchProductData(
      searchQuery,
      searchBy,
      DEPARTMENT_LOCATIOIN,
      pageNumber,
      pageSize,
    );
    fetchTotalCount(searchQuery, searchBy);
  }, [
    searchQuery,
    searchBy,
    DEPARTMENT_LOCATIOIN,
    pageNumber,
    pageSize,
    fetchProductData,
    fetchTotalCount,
  ]);

  useEffect(() => {
    if (location && location.state) {
      const { searchQuery: navQuery, filterBy } = location.state;
      if (typeof navQuery === "string" && navQuery.trim() !== "") {
        setSearchQuery(navQuery);
      }
      if (filterBy) setSearchBy(filterBy);
    }
  }, [location]);

  const refreshProducts = useCallback(() => {
    fetchProductData(
      searchQuery,
      searchBy,
      DEPARTMENT_LOCATIOIN,
      pageNumber,
      pageSize,
    );
    fetchTotalCount(searchQuery, searchBy);
  }, [
    fetchProductData,
    fetchTotalCount,
    searchQuery,
    searchBy,
    DEPARTMENT_LOCATIOIN,
    pageNumber,
    pageSize,
  ]);

  const handleProductSelect = (product) => {
    console.log("Selected Product:", product);
  };

  return (
    <div className="h-screen w-[calc(100vw-5rem)]">
      <ProductListing
        isFullPage={true}
        modalSuggestions={products}
        loading={loading}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        onSearchQueryChange={setSearchQuery}
        handleProductSelect={handleProductSelect}
        onRefresh={() =>
          fetchProductData(
            searchQuery,
            searchBy,
            DEPARTMENT_LOCATIOIN,
            pageNumber,
            pageSize,
          )
        }
        searchQuery={searchQuery}
        pageNumber={pageNumber}
        pageSize={pageSize}
        totalRows={totalRows}
        onPageChange={setPageNumber}
      />
    </div>
  );
};

export default StockManagement;
